import { ReactComponent as IconFullStar } from "../../../layout/others/icon_star_active_yellow.svg";
import { ReactComponent as IconEmptyStar } from "../../../layout/others/icon_star_idle.svg";
import { ReactComponent as IconHalfStar } from "../../../layout/others/icon_star_half_yellow.svg";

const RatingItem = (props) => {
  const startType = { empty: 0, half: 1, full: 2 };
  const starValue = 1;
  const numberOfStars = 5;
  const starsToRender = [];

  function onChange(index) {
    let rating = index * starValue + 1;
    if (rating === props.skill.rating && props.onChange) {
      //same value was passed,cut de star value in half
      props.onChange(rating - 0.5, props.skill.id);
    } else if (props.onChange) {
      props.onChange(rating, props.skill.id);
    }

    calculateNumberOfStars();
  }

  function calculateNumberOfStars() {
    for (let index = 0; index < numberOfStars; index += starValue) {
      let remainder = props.skill.rating - index;
      if (remainder >= starValue) {
        starsToRender.push(startType.full);
      } else if (remainder > 0 && remainder < starValue)
        starsToRender.push(startType.half);
      else {
        starsToRender.push(startType.empty);
      }
    }
  }

  calculateNumberOfStars();

  return starsToRender.map((star, index) => {
    if (star === startType.full)
      return (
        <span
          style={{ cursor: "pointer" }}
          key={index}
          onClick={() => {
            onChange(index);
          }}
        >
          <IconFullStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
    else if (star === startType.half)
      return (
        <span
          style={{ cursor: "pointer" }}
          key={index}
          onClick={() => {
            onChange(index);
          }}
        >
          <IconHalfStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
    else
      return (
        <span
          style={{ cursor: "pointer" }}
          key={index}
          onClick={() => {
            onChange(index);
          }}
        >
          <IconEmptyStar style={{ verticalAlign: "baseline" }} />
        </span>
      );
  });
};

export default RatingItem;
